import $ from 'jquery';
import {cookiesAccepted, createCookie} from './cookies';

const namespace = 'cookiebar';

export default class CookieBar {
  constructor(el, options) {
    this.options = $.extend(
      true,
      {
        classes: {
          visible: 'is-visible',
          required: 'is-required',
        },
        delay: 2000,
      },
      options,
    );

    this.$el = $(el);

    this.bind();
  }

  bind() {
    $(document).ready(this.check.bind(this));
    this.$el.on(`click.${namespace}`, this.handleClick.bind(this));
  }

  handleClick() {
    createCookie();
    this.$el.removeClass(this.options.classes.visible);
  }

  check() {
    if (cookiesAccepted()) {
      return;
    }

    this.$el.addClass(this.options.classes.required);

    window.setTimeout(() => {
      this.$el.addClass(this.options.classes.visible);
    }, this.options.delay);
  }
}
